import { render, staticRenderFns } from "./InputTicketing.vue?vue&type=template&id=06ca29f0&scoped=true&"
import script from "./InputTicketing.vue?vue&type=script&lang=js&"
export * from "./InputTicketing.vue?vue&type=script&lang=js&"
import style0 from "./InputTicketing.vue?vue&type=style&index=0&id=06ca29f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca29f0",
  null
  
)

export default component.exports